import { memo } from "react";
import type { NavigationMenuTriggerProps as RadixNavigationMenuTriggerProps } from "@radix-ui/react-navigation-menu";
import { NavigationMenuTrigger } from "@/components/ui/navigation-menu";
import { cn } from "@/lib/utils";

export type NavigationTriggerProps = {} & RadixNavigationMenuTriggerProps;

const NavigationTrigger = ({
  className,
  children,
  ...rest
}: NavigationTriggerProps) => {
  return (
    <NavigationMenuTrigger
      className={cn(
        "group text-md [&>svg]:w-5 [&>svg]:h-5 !bg-transparent hover:!bg-transparent focus:!bg-transparent data-[state=open]:!bg-transparent hover:!text-[#4381E5] data-[state=open]:!text-[#4381E5] cursor-pointer",
        className
      )}
      {...rest}
    >
      {children}
      <div
        className="absolute bottom-[-10px] left-4 right-4 h-[2px] bg-[#4381E5] transition-opacity duration-300 
    group-data-[state=open]:opacity-100 opacity-0"
      />
    </NavigationMenuTrigger>
  );
};

export default memo(NavigationTrigger);
